import { useEffect } from 'react';
import { withAppContext } from './AppContext';

function WhiteBack({
    children,
    app: {
        on: { background },
    },
}) {
    useEffect(() => {
        background.notify(true);
        return () => background.notify(false);
    }, []);
    return children || null;
}

export default withAppContext(WhiteBack);
